import { get } from './try';
import { CONFIG_URL, CONFIG_SDK_VERSION } from '../../config'; // 获取sdk版本

export var getVersion = function getVersion() {
  return String(CONFIG_SDK_VERSION); // packageJson.version
};
export var logger = function logger(msg) {
  console.log(new Date(), msg);
};
/**
 * 获取host
 * @param {object} config 用户配置
 */

export var getHost = function getHost() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return config.third_host || config.reportThirdHost ? config.reportDevelopEnv ? CONFIG_URL.HOST_THIRD_DEV : CONFIG_URL.HOST_THIRD_ONLINE : config.reportDevelopEnv ? CONFIG_URL.HOST_DEV : CONFIG_URL.HOST_ONLINE;
};